export default "__VITE_ASSET__1d1b6639__"